export class TargetElementObserverError extends Error {
  constructor(...args) {
    super(...args);
    this.name = 'TargetElementObserverError';
  }
}